export function formatUserChoiceMessage(field, option) {
  const label = option?.label || option?.value
  const value = option?.value

  switch (field) {
    case 'asana_project':
      return `Use Asana project "${label}" (project_id: ${value})`
    case 'asana_workspace':
      return `Use Asana workspace "${label}" (workspace_id: ${value})`
    case 'jira_project':
      return `Use Jira project ${value}`
    case 'github_repo':
      return (
        `GitHub context is already set to ${value}. ` +
        'Continue with my previous request — do not ask me to pick a repository again ' +
        'and do not call set_session_github_context again.'
      )
    default:
      return `Selected "${label}" (${value})`
  }
}

export function formatGithubContextMessage(repo, branch) {
  if (!repo) return ''
  const branchLabel = branch || 'main'
  return (
    `GitHub context is already set to ${repo} on branch ${branchLabel}. ` +
    'Continue with my previous request — do not ask me to pick a repository again ' +
    'and do not call set_session_github_context again.'
  )
}

export const INLINE_CHOICE_LIMIT = 8
